import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Loads the edited timestamps for a given avatar
 *
 * @param {number} id - the avatar id to check
 * @returns {object} the result
 */
async function getAvatarEditTimestampsById (id) {
  const res = await fetchJSONData(
    `${constants.API_URL}/metadata/edits/${id}?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )

  if (!res.success) {
    return {
      success: false,
      data: []
    }
  }

  return res
}

export default getAvatarEditTimestampsById
